import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from '@react-oauth/google';

import './css/login.css'

import Popup from "../components/Popup";
import { AppContext } from "../../Context";
import Fetch, { Loader, dateToText, user_login } from "../inc/Fetch";
import { Img, Tasks, GoogleLogin } from "../components/Elements";
import { Input } from "../components/Form";


export default function Login() {
	
	const { t } = useTranslation();
	let navigate = useNavigate();

	const {siteData, successData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [success, setsuccess] = successData;
	const [userinfo, setuserinfo] = user;

	

	const [loader, setloader] = useState(false);
	const [values, setvalues] = useState({});


	async function login(e) {
		e.preventDefault();

		setloader(true);

		let res = await user_login(values);
		if (res?.token) {
			setsuccess({ short: t("login_success") });
			setuserinfo(res?.userinfo);

			window.history.replaceState(null, null, "/");
			
			setTimeout(() => {
				navigate(-1);
			}, 2500);
		} else {
			setsuccess({ short: t("error",  { returnObjects: true })[res?.error], error: true });
		}
		
		setloader(false);
		
	}

	
	

	return (
		<>
			{loader && <Loader />}
			<Popup 
				className="loginPopBox"
			>
				<div className='leftLogin'>
					<h1>{t("login_title")}</h1>
					<p>{t("login_sub")}</p>
				</div>
				<form onSubmit={login} className='loginForm'>

					<div className='loginFormIn'>
						<Input
							// title="email"
							placeholder={t("login_email")}
							type="text"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									email: v
								}))
							}
						/>

						<Input
							// title="Password"
							type="password"
							placeholder={t("login_pass")}
							onChange={(v) => 
								setvalues(p => ({
									...p,
									pass: v
								}))
							}
						/>

						<a className='forgot'>{t("login_forget")}</a>
						
						<div className='loginButtonBox'>
							<button className='btn login'>{t("login")}</button>
							{siteInfo?.settings?.reg?.val ? <Link to="/reg" replace={true} state={{previousLocation: { pathname:"/"}, }} className='btn regBtn'>{t("login_reg")}</Link> : false}
						</div>
						

						
					</div>

					<div className='loginOr'>
						<span>{t("or")}</span>
						<hr />
					</div>


					<GoogleLogin />
					

				</form>

				

			</Popup>
			
		</>
	)
}
